module.exports = __webpack_public_path__ + "images/table_yes.svg?39316185";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/table_yes.svg
// module id = 238
// module chunks = 7